import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { motion } from 'framer-motion';

import aboutBg from '../assets/img/About/Abouts.webp';
import Cover1 from '../assets/img/Cover/Cover2.webp';
import Cover2 from '../assets/img/Cover/Cover3.webp';
import Cover3 from '../assets/img/Cover/Cover4.webp';
import founders from '../data/founders';
import Image1 from '../assets/img/Contact/image1.webp';
import Image2 from '../assets/img/Contact/image2.webp';
import Image3 from '../assets/img/Contact/image2.webp';

const About = () => {
  const navigate = useNavigate();

  const handleGetInvolvedClick = () => {
    navigate('/getinvolved'); // Navigate to '/getinvolved' when the button is clicked
  };
// Animation variant
const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};
  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="relative h-[60vh] md:h-[80vh] w-full overflow-hidden">
        <Swiper
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          navigation={false}
          modules={[Pagination]}
          className="h-full"
        >
          {[Cover1, Cover2, Cover3].map((cover, index) => (
            <SwiperSlide key={index}>
              <div
                className="h-full w-full bg-cover bg-center"
                style={{ backgroundImage: `url(${cover})` }}
              >
                <div className="bg-black/60 h-full w-full flex flex-col items-center justify-center text-center text-white px-4">
                  <h1 className="text-3xl md:text-4xl lg:text-4xl font-bold uppercase mt-4 p-4 tracking-wider inline-block font-playfair animate-fade-up">
                    about us
                  </h1>
                  <p className="text-xl md:text-2xl font-light uppercase mt-2 tracking-wider font-playfair animate-fade-up">
                    Bringing change with compassion and care.
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* About Us Section */}
      <section className="py-10 bg-white">
        <div className="mx-auto flex flex-col lg:flex-row justify-center items-center w-[90%] lg:w-[70%] gap-12 relative z-10">
          {/* Left Side */}
          <div className="space-y-6">
          <p className="text-sm text-[#90444D] font-semibold uppercase font-playfair tracking-wider">About Our Organization</p>
          <h2 className="text-2xl md:text-3xl font-bold font-playfair text-gray-900 tracking-wider">
            We are here to support<br />
            <span className="uppercase text-[#90444D]">Children & Elders</span>
          </h2>
            <p className="leading-relaxed text-green-800">
              Christian Care for Children and Elders Association (CCCEA) is an indigenous Non-Governmental Organization established and registered at the Ministry of Justice in September 2006, and began its actual operations in November 2006. <br /><br />
              As identified by the Bole Sub-City Social Affairs Office, a significant number of households struggle to provide food and education for their children. A preliminary survey and home visits conducted by CCCEA’s social workers revealed that children (ages 4–16) attending Bethany Zare Elementary School (Grades 1–8) come from families living in extremely challenging conditions. <br /><br />
              Many of these children are orphans who lost their parents due to HIV/AIDS and now live with extended family members—such as aunts, uncles, or grandparents—or even non-relatives acting as guardians. These caretakers often lack the resources to meet the children's basic needs.
            </p>
            {/* Image Grid */}
            <div className="grid grid-cols-2 gap-8 mt-8">
              <img
                src={Image1}
                alt="Smiling girl"
                className="shadow-custom w-full h-[200px] object-cover"
              />
              <img
                src={Image3}
                alt="Smiling kids"
                className="shadow-custom w-full h-[200px] object-cover"
              />
            </div>
          </div>

          {/* Right Side */}
          <div className="space-y-6">
            <img
              src={Image2}
              alt="Teacher with child"
              className="shadow-custom w-full h-[250px] object-cover"
            />
            <p className="leading-relaxed text-green-800">
              The major challenges faced by the children include:
            </p>
            <ul className="space-y-3 text-sm text-green-800">
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>Inability to maintain personal hygiene</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>Lack of basic needs (shelter, clothing, and medical care)</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>Inability to afford school materials</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>Difficulty concentrating in class due to hunger (sometimes leading to fainting)</span>
              </li>
            </ul>
            <p className="leading-relaxed text-green-800">
              In response, CCCEA has also initiated income-generating programs with 15 women, enabling them to improve their earnings and become more self-reliant. The main activities are:
            </p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-green-600 mt-1">✓</span>
                <span>Children Support Program</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">✓</span>
                <span>Elders Support Program</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Our Impact Section */}
      <section
        className="relative text-white py-20 px-4 text-center bg-cover bg-center"
        style={{ backgroundImage: `url(${aboutBg})` }}
      >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative z-10 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-playfair font-bold mb-12">OUR IMPACT</h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 text-white">
          <div>
            <p className="text-5xl font-bold">150+</p>
            <p className="uppercase text-sm mt-3 tracking-wider">Children Supported</p>
          </div>
          <div>
            <p className="text-5xl font-bold">500+</p>
            <p className="uppercase text-sm mt-3 tracking-wider">Families Reached</p>
          </div>
          <div>
            <p className="text-5xl font-bold">15</p>
            <p className="uppercase text-sm mt-3 tracking-wider">Women Empowered</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-16 mt-16 md:text-left max-w-5xl mx-auto text-center">
          <div>
            <p className="font-semibold mb-2">Children Program</p>
            <ul className="list-disc list-inside space-y-1">
              <li>School fees, transport & supplies</li>
              <li>School uniforms, shoes, hygiene kits</li>
              <li>Food and housing support</li>
              <li>Medical aid and guidance</li>
            </ul>
          </div>

          <div>
            <p className="font-semibold mb-2">Elders Program</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Home food support</li>
              <li>Medical assistance</li>
              <li>HIV/AIDS family support</li>
            </ul>
          </div>

          <div>
            <p className="font-semibold mb-2">Income Generation</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Loans for 15+ women</li>
              <li>Small business initiatives</li>
              <li>Improving family self-sufficiency</li>
            </ul>
          </div>
        </div>
      </div>
     </section>

{/* Mission, Vision, Values Section */}
<section className="py-20 bg-white">
  <motion.div
    className="mx-auto flex flex-col lg:flex-col justify-center items-center w-[90%] lg:w-[70%] gap-12 relative z-10"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
    variants={fadeUp}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <motion.div
      className="w-full"
      variants={fadeUp}
      transition={{ duration: 0.6 }}
    >
      <p className="text-sm text-[#90444D] font-semibold uppercase font-playfair tracking-wider">
        Our Organization have
      </p>
      <h2 className="text-2xl md:text-3xl font-bold font-playfair text-gray-900 tracking-wider">
        We have set of visions to support<br />
        <span className="uppercase text-[#90444D]">Children & Elders</span>
      </h2>
    </motion.div>

    <div className="w-full px-4 grid md:grid-cols-3 gap-10">
      {/* Mission */}
      <motion.div
        className="flex flex-col items-center text-center"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        <div className="w-20 h-20 rounded-full border-4 border-[#E91E63] flex items-center justify-center mb-4">
          <i className="fas fa-chart-line text-[#E91E63] text-2xl"></i>
        </div>
        <h3 className="font-bold text-[#E91E63] uppercase mb-2 font-playfair">Our Mission</h3>
        <p className="text-gray-500">
          To contribute to the well-being of vulnerable children and elders in Bole Sub City by providing access to education, nutrition, medical support, and sustainable livelihood opportunities through compassionate and community-centered care.
        </p>
      </motion.div>

      {/* Vision */}
      <motion.div
        className="flex flex-col items-center text-center"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <div className="w-20 h-20 rounded-full border-4 border-[#2196F3] flex items-center justify-center mb-4">
          <i className="fas fa-eye text-[#2196F3] text-2xl"></i>
        </div>
        <h3 className="font-bold text-[#2196F3] uppercase mb-2 font-playfair">Our Vision</h3>
        <p className="text-gray-500">
          To build a just and compassionate society where every Child and Elder especially those affected by poverty, HIV/AIDS, and social marginalization has access to basic human needs, quality education, healthcare, and a supportive environment that nurtures their potential and dignity.
        </p>
      </motion.div>

      {/* Values */}
      <motion.div
        className="flex flex-col items-center text-center"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <div className="w-20 h-20 rounded-full border-4 border-[#4CAF50] flex items-center justify-center mb-4">
          <i className="fas fa-trophy text-[#4CAF50] text-2xl"></i>
        </div>
        <h3 className="font-bold text-[#4CAF50] uppercase mb-2 font-playfair">Our Values</h3>
        <p className="text-gray-500">
          Compassion: We serve with love, understanding, and empathy for those in need and  We are dedicated to long-term, impactful service in the lives of children and elders.<br />
          Empowerment: We believe in creating opportunities for self-sufficiency through income-generating activities.<br />
          Integrity: We operate with transparency, accountability, and a deep sense of responsibility.
        </p>
      </motion.div>
    </div>
  </motion.div>
</section>
          {/* Call to Action */}
      <section className="relative bg-[#164F42] text-white py-20 px-4 text-center overflow-hidden font-playfair">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-cover bg-center" style={{ backgroundImage: "url('/path-to-heart-background.png')" }}></div>

        <div className="relative z-10 max-w-2xl mx-auto">
          <p className="text-sm uppercase tracking-wide text-[#B5E8D5] mb-2">Help us care for them</p>
          <h2 className="text-3xl md:text-4xl font-semibold mb-4 leading-snug">
            Your donation means a lot for us.<br />
            <span className="font-medium">Donate what you can.</span>
          </h2>
          <button className="mt-6 bg-[#90444D] text-white px-8 py-3 rounded-full font-semibold shadow-md hover:bg-[#90444D] transition" onClick={handleGetInvolvedClick}>
            GET INVOLVED
          </button>
        </div>
      </section>

{/* Founders Section with Framer Motion Animation Only */}
<section className="py-20 bg-gray-50">
        <motion.div
          className="mx-auto flex flex-col items-center w-[90%] lg:w-[70%] gap-12 relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <motion.div
            className="w-full"
            variants={fadeUp}
            transition={{ duration: 0.6 }}
          >
            <p className="text-sm text-[#90444D] font-semibold uppercase font-playfair tracking-wider">
              Visionary Founders
            </p>
            <h2 className="text-2xl md:text-3xl font-bold font-playfair text-gray-900 tracking-wider">
              Meet Some of Visionary Creaters
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 md:gap-12 gap-2">
            {founders.map((founder, index) => (
              <motion.div
                key={index}
                className="flex items-center gap-8 justify-center text-center"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <div className="w-[200px] h-[200px]  rounded-full overflow-hidden mb-4">
                  <img
                    src={founder.images}
                    alt={founder.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="text-xl font-bold font-playfair text-customGreen">
                    {founder.name}
                  </h4>
                  {founder.position && (
                    <p className="font-light text-gray-700">{founder.position}</p>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>
    </div>
  );
};




export default About;
